import axios from "axios";

// Helper
import { baseURL } from "../Utils";

const useAxiosNoAuth = () => {
  const axiosInstance = axios.create({
    baseURL,
  });

  axiosInstance.interceptors.request.use(async (req) => {
    return req;
  });

  return axiosInstance;
};

export default useAxiosNoAuth;
